export default __webpack_public_path__ + "static/media/clinic2.22852293.jpg";